<template>
    <div id="amap-demo1" class="amap-demo">
    </div>
 </template>
<script>
export default {
    data() {
        return {
            icon: require('../assets/images/plane_map.svg'),
            flight: {},
            map: null,
        }
    },
    mounted() {
        // this.init(this.flight);
    },
    watch: {
        '$store.state.flight' () {
            this.flight = this.$store.state.flight
        },

        flight() {
            this.init(this.flight)
        }
    },
    methods: {
        init(flight) {
            console.log(flight)
            let that = this
            let dashed = ['schedule', 'cancel', 'diverted flight cancel', 'returned flight cancel', 'cancel in advance', 'delay']
            const map = new AMap.Map('amap-demo1', {
                zoom: 12,
                lang: 'en',
                zoomEnable: false,
                doubleClickZoom: false,
                keyboardEnable: false,
                scrollWheel: false,
                touchZoom: false
            })
            map.clearMap()
            let path = [[flight.DepAirportLon,flight.DepAirportLat], [flight.ArrAirportLon,flight.ArrAirportLat]]
            let polyline = new AMap.Polyline({
                map: map,
                zIndex: 5,
                path: path,  
                strokeColor:"#64ADE5",//线颜色  
                strokeOpacity:1,//线透明度  
                strokeWeight:3,//线宽  
                strokeStyle: flight.FlightState.indexOf('arrival') !== -1 ? "solid" : "dashed",//线样式  
            })
            AMapUI.load(['ui/misc/PathSimplifier', 'lib/$', 'lib/utils'], function(PathSimplifier, $, utils) {
                if (!PathSimplifier.supportCanvas) {
                    alert('当前环境不支持 Canvas！')
                    return
                }
                let content
                if (flight.FlightState !== 'arrival') {
                    content = PathSimplifier.Render.Canvas.getImageContent(that.icon, function onload() {
                        //图片加载成功，重新绘制一次
                        pathSimplifierIns.renderLater()
                    })
                }
               
                const defaultRenderOptions = {
                    pathLineStyle: {
                        strokeStyle: 'transparent',
                        borderStyle: 'transparent',
                        width: 0.5,
                        borderWidth: 0
                    },
                    startPointStyle: {
                        fillStyle: 'transparent',
                        lineWidth: 0,
                        width: 0
                    },
                    endPointStyle: {
                        fillStyle: 'transparent',
                        lineWidth: 0,
                        width: 0
                    },
                    pathNavigatorStyle: {
                        initRotateDegree: flight.FlightState.indexOf('departure') === -1 ? 260 : 0,
                        width: 24,
                        height: 24,
                        autoRotate: true,
                        content: content,
                        lineWidth: 0.5,
                        pathLinePassedStyle: {
                            lineWidth: 3,
                            strokeStyle: '#64ADE5',
                            borderWidth: 0,
                            borderStyle: '#64ADE5',
                            dirArrowStyle: false
                        }
                    }
                }
                var pathSimplifierIns = new PathSimplifier({
                    zIndex: 999,
                    // autoSetFitView:true,
                    map: map, //所属的地图实例
                    getPath: function(pathData, pathIndex) {
                        return pathData.path
                    },
                    renderOptions: defaultRenderOptions
                })
                window.pathSimplifierIns = pathSimplifierIns
                //设置数据
                pathSimplifierIns.setData([{
                    name: '路线',
                    path: path
                }])
                //对第一条线路（即索引 0）创建一个巡航器
                var navg1 = pathSimplifierIns.createPathNavigator(0, {
                    loop: true, //循环播放
                    speed: 1000000 //巡航速度，单位千米/小时
                })
                navg1.start();
                if (flight.FlightState.indexOf('departure') === -1) {
                    navg1.pause()
                }
            });
            AMapUI.loadUI(['overlay/SimpleMarker'], (SimpleMarker) => {
                let obj1 = {Q:flight.DepAirportLon, P:flight.DepAirportLat}
                let obj2 = {Q:flight.ArrAirportLon, P:flight.ArrAirportLat}
                // 起点
                new SimpleMarker({
                    iconStyle: '',
                    iconLabel: {
                        innerHTML: '<div class="bg-con1">'+ flight.FlightDep + '</div>',
                    },
                    offset: new AMap.Pixel(-10,-15),
                    map: map,
                    showPositionPoint: false,
                    position: path[0],
                    zIndex: 100001
                })
                // 终点
                new SimpleMarker({
                    iconStyle: '',
                    iconLabel: {
                        innerHTML: flight.FlightState.indexOf('arrival') === -1 ? '<div class="bg-con">'+ flight.FlightArr + '</div>' : '<div class="bg-con"><span class="arrival-icon"></span>'+ flight.FlightArr + '</div>',
                    },
                    offset: new AMap.Pixel(-8,-10),
                    map: map,
                    showPositionPoint: false,
                    position: path[1],
                    zIndex: 10001
                })
                map.setFitView()
            })
        },

    }
}
</script>

<style>
#amap-demo1 {
    height: 240px;
}
.bg{
    padding-left:61px; height: 61px;
    min-width:100px;
}
.bg-con,.bg-con1{
    font-size: 16px;
    /* font-weight: bold;*/
    padding:0 10px 0 20px;
    background-repeat:no-repeat;
    background-size: 48%;
    position: relative;
}

.bg-con{
    background-image:url(../assets/images/pin_origin_ED.svg);
}

.bg-con1{
    background-image:url(../assets/images/pin_destination_ED.svg);
}

.arrival-icon {
    z-index: 9999;
    position: absolute;
    top: -20px;
    left: 0;
    width: 24px;
    height: 24px;
    background-image:url(../assets/images/plane_map.svg);
    background-size: 100%;
}
</style>